import React from 'react';

import FaceOcclusionSubForm from '@vlabs/pages/handlers/forms/FaceOcclusionSubForm';
import { Step } from '@vlabs/uikit';
import cn from 'classnames';

import st from './shared.module.sass';

function StepFaceOcclusion() {
  return (
    <Step
      className={cn(st.Step, st.FoldedStep)}
      withPadding={false}
    >
      <FaceOcclusionSubForm />
    </Step>
  );
}

StepFaceOcclusion.fieldNames = [
  'estimate_face_occlusion',
  'filters',
];

export { StepFaceOcclusion };
